/* eslint-disable dot-notation */
import { service } from '../api/axios';

export const login = (loginUser: string) =>
  service.post('/login', loginUser).then((response) => response.data);

export const logoutService = () =>
  service.post('/logout').then((response) => response.data);

export const register = (registerNewUser: string) =>
  service.post('/register', registerNewUser).then((response) => response.data);

export const getAllUsers = () =>
  service.get('/users').then((response) => response.data);

export const forgot = (email: string) =>
  service.post('/forgot', { email }).then((response) => response.data);

export const newPasswordService = (
  newPassword: string,
  confirmPassword: string,
  token: string
) =>
  service
    .post(`/new-password/${token}`, { newPassword, confirmPassword })
    .then((response) => response.data);

// Admin editing another user. PUT /profile is a SELF-update — the server
// always writes to the JWT user and ignores any id — so using it from the
// admin panel silently overwrote the admin own profile with the target data.
export const adminUpdateUserService = (userId: string, userData: any) =>
  service.put(`/users/${userId}`, userData).then((response) => response.data);

export const updateUserService = (
  userData: any // TODO: Add typing
) => service.put(`/profile`, userData).then((response) => response.data);

export const getUser = async () => {
  const res = await service.get('/user');
  return res.data.data;
};

export const deleteUser = async (userId: string) => {
  const res = await service.delete(`/users/${userId}`);
  return res.data.data;
};

export const getUserProfileService = (user: string) =>
  service.get(`/profile/${user}`).then((response) => response.data);

export const followUser = (userId: string) =>
  service.put(`/${userId}/follow`).then((response) => response.data);

export const unfollowUser = (userId: string) =>
  service.put(`/${userId}/unfollow`).then((response) => response.data);

export const updateZohoGroups = () =>
  service.post(`/users/updateZohoGroups`).then((response) => response.data);

export type TMevosUser = {
  _id: string;
  Email?: string;
  Voornaam: string;
  Achternaam: string;
  Stadseel: string;
  Stagiair: false;
  Branch: string;
  FetchedAt: string;
};
export const getZohoUsers = () =>
  service.get<TMevosUser[]>(`/users/zoho`).then((response) => response.data);
